import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import NavButtons from 'components/Downloads/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};